import { format, isSameDay, isAfter, isSameHour } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { i18n } from "i18n";
import { calendarDateFormat, calendarHourFormat } from "../const";
import { clearStartOfTheDay } from "./clearStartOfTheDay";

interface IFormatDateTime {
  startDateUtc: string;
  endDateUtc?: string;
  allDay: boolean;
}

export function formatCalendarDateTime({
  startDateUtc,
  endDateUtc,
  allDay,
}: IFormatDateTime) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const startDate = utcToZonedTime(startDateUtc, timeZone);
  const endDate = endDateUtc ? utcToZonedTime(endDateUtc, timeZone) : startDate;

  const formattedStartDate = format(startDate, calendarDateFormat);
  const formattedEndDate = format(endDate, calendarDateFormat);
  const formattedStartTime = format(startDate, calendarHourFormat);
  const formattedEndTime = format(endDate, calendarHourFormat);

  const isSameDayDate = isSameDay(startDate, endDate);
  const isExactHour = isSameDayDate && isSameHour(endDate, startDate);
  const isHoursRange = isSameDayDate && isAfter(endDate, startDate);

  const formattedDate = isSameDayDate
    ? formattedStartDate
    : `${formattedStartDate} - ${formattedEndDate}`;

  if (allDay) return formattedDate;

  if (isExactHour)
    return i18n.t("agent:tagminAvailabilityCalendar.exactTime", {
      date: formattedDate,
      time: formattedStartTime,
    });

  if (isHoursRange)
    return `${formattedDate} ${formattedStartTime} - ${formattedEndTime}`;

  return isSameDayDate
    ? formattedStartDate
    : `${formattedStartDate} ${clearStartOfTheDay(
        formattedStartTime
      )} - ${formattedEndDate} ${clearStartOfTheDay(formattedEndTime)}`;
}
